import { useEffect } from 'react'
import { navigate } from 'gatsby-link'

import { useFirebolt } from '@iq-firebolt/client'
import useFormFlow from 'hooks/useFormFlow'

export const useBankDataHook = () => {
  const { currentStep } = useFormFlow()
  const { remoteErrors } = useFirebolt()
  useEffect(() => {
    const firstError = remoteErrors[0]
    const currentFields = currentStep?.data?.fields?.map((field) => field.slug)
    const isFieldValidation = currentFields.includes(firstError?.slug)

    if (!!firstError && !isFieldValidation) {
      navigate('/produto/bb/erro-no-processamento')
    }
  }, [remoteErrors])
}
